import FolderNodeViewState from '../store/schema/FolderNodeViewState';
import setMoveToFolderNodeViewState from '../actions/setMoveToFolderNodeViewState';
import toggleMoveToFolderNodeViewState from '../actions/toggleMoveToFolderNodeViewState';
import { getStore } from '../store/Store';
import { orchestrator } from 'satcheljs';

/**
 * Orchestrator which toggles moveToFolderNodeViewState
 */
export default orchestrator(toggleMoveToFolderNodeViewState, actionMessage => {
    const { folderId } = actionMessage;
    const folderViewState = getStore().moveToFolderNodeViewStates.get(folderId);

    setMoveToFolderNodeViewState(folderId, {
        isExpanded: !folderViewState.isExpanded,
    } as FolderNodeViewState);
});
